import styled, { css } from 'styled-components';
export const AccordionBase = styled.div.attrs({
    className: 'accordion',
}) `
  display: flex;
  flex-direction: column;

  & > *:first-child {
    border-top: 1px solid rgba(25, 25, 25, 0.16);
  }

  &.border-t-0 > *:first-child {
    border-top: none;
  }

  &.border-b-0 > *:last-child {
    border-bottom: none;
  }
`;
export const RowBase = styled.div.attrs({
    className: 'row',
}) `
  display: flex;
  flex-direction: column;

  border-bottom: 1px solid rgba(25, 25, 25, 0.16);
`;
export const HeaderLevel = styled.div `
  width: 100%;
`;
export const Header = styled.button `
  width: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;

  font-weight: 700;
  font-size: 16px;
  line-height: 24px;

  padding: 16px 0;
  margin: 0;

  color: var(--color-on-background);
  background: transparent;
  border: none;

  &:hover {
    color: var(--color-primary-variant);
    background: var(--color-overlay-hover-darken);
    cursor: pointer;
  }

  &:active {
    color: var(--on-background);
    background: var(--color-overlay-pressed-darken);
  }

  &:focus:not(:hover) {
    background: var(--color-overlay-pressed-darken);
  }

  &:focus:not(:focus-visible):not(:hover) {
    outline: none;
    background: var(--background);
  }

  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > i {
    margin-left: 16px;
    ${({ $isOpen }) => $isOpen &&
    css `
        color: var(--color-primary-variant);
      `}
  }
`;
export const Content = styled.div `
  padding: 16px 0px 32px 0px;
`;
